export default "__VITE_ASSET__689e75af__"